import { Injectable} from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  constructor(
    private readonly datePipe: DatePipe
  ) {
    super();
  }

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day : Number.parseInt(date[2], 10),
        month : Number.parseInt(date[1], 10),
        year : Number.parseInt(date[0], 10),
      };
    }
    return null;
  }

   toModel(date: NgbDateStruct | null): string | null {
    return date ? this.datePipe.transform(new Date(date.year, date.month-1, date.day), 'yyyy-MM-ddTHH:mm:ss') : null; // whatever format you need.
  } 
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : Number.parseInt(date[0], 10),
        month : Number.parseInt(date[1], 10),
        year : Number.parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}
